import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getConfig } from '../../../utils/config';

const Footer2 = () => {
    const config = getConfig();
    const c = config?.footer;
    const history = useHistory();
    const navigateTnC = () => {
        history.push(
            `/terms-and-conditions${
                config?.name === 'Brigade' || c.enableAdminTerms === true
                    ? '?login=true'
                    : ''
            }`
        );
    };
    return (
        <div
            className={`bg-secondary-content md:pt-4 xl:pt-2 ${
                c?.containerClassName || ''
            }`}
        >
            <footer className=" md:pl-12 md:pr-4 lg:pl-4 lg:pr-2 xl:pl-10 xl:pr-7 3xl:pl-10 3xl:pr-10 font-Corporate_S font-medium ">
                {c?.expandContent ? (
                    <details>
                        <summary
                            className={` ${config?.blogs?.fontHeading} ${
                                c?.expandClassName ||
                                'px-10 lg:pr-6 xl:pl-4 self-center md:w-[85%] text-[14px] lg:text-[13px] xl:text-[14px] 3xl:text-[15px] leading-5 tracking-tight text-white'
                            }`}
                        >
                            {' '}
                            {c?.expandName}{' '}
                        </summary>
                        <div className="  flex flex-col md:flex-row justify-center">
                            <div
                                className={`self-center md:w-[13%] lg:w-[14%] lg:pl-3 ${
                                    c?.logoClassName || ''
                                }`}
                            >
                                <img
                                    className=" h-auto px-24 my-4 w-full md:h-auto md:w-auto md:px-0 md:py-0 xl:pl-0 xl:pr-2 2xl:pr-8 3xl:pr-10 "
                                    src={
                                        c?.logo ||
                                        'https://cdn.loyalie.in/28602817.png'
                                    }
                                />
                            </div>
                            <p
                                className={`${config?.blogs?.fontBody} ${
                                    c?.expandContentClassName ||
                                    'px-10 lg:pr-6 xl:pl-4 self-center md:w-[85%] text-[14px] lg:text-[13px] xl:text-[14px] 3xl:text-[15px] leading-5 tracking-tight text-white'
                                } `}
                            >
                                {c?.content}

                                <p
                                    className={`text-white text-[12px] 3xl:text-[15px] text-right mr-7 pb-2 cursor-pointer ${
                                        config?.blogs?.fontHeading
                                    } ${c?.termsAndConditionsClassName || ''}`}
                                    onClick={navigateTnC}
                                >
                                    {c?.termsAndConditionsContent ||
                                        '*T&C Apply'}
                                </p>
                            </p>
                        </div>
                    </details>
                ) : (
                    <>
                        <div className=" flex flex-col md:flex-row justify-center">
                            <div
                                className={`self-center md:w-[15%] lg:w-[16%] lg:pl-3 ${
                                    c?.logoClassName || ''
                                }`}
                            >
                                <img
                                    className=" h-auto px-24 my-4 w-full md:h-auto md:w-auto md:px-0 md:py-0 xl:pl-0 xl:pr-2 2xl:pr-8 3xl:pr-10 "
                                    src={
                                        c?.logo ||
                                        'https://cdn.loyalie.in/28602817.png'
                                    }
                                />
                            </div>
                            <p
                                className={`md:flex-1 mt-4 md:mt-0 pl-10 pr-10 lg:pl-6 lg:pr-4 xl:pl-4 xl:pr-6 text-[10.5px] 3xl:text-[15px] leading-[22px] tracking-tight text-white ${
                                    config?.blogs?.fontBody
                                } ${c?.contentClassName || ''}`}
                            >
                                {c?.content}
                            </p>
                        </div>
                        <p
                            className={`text-white text-[12px] 3xl:text-[15px] text-right mr-7 pb-2 cursor-pointer ${
                                config?.blogs?.fontHeading
                            } ${c?.termsAndConditionsClassName || ''}`}
                            onClick={navigateTnC}
                        >
                            {c?.allRightsReservedContent
                                ? c?.allRightsReservedContent
                                : '*T&C Apply'}
                        </p>
                    </>
                )}
            </footer>
            {c?.allRightsReservedVisible && (
                <p
                    className={`text-[12px] md:text-[16px] bg-white w-full mx-auto text-center py-2 ${
                        config?.blogs?.fontBody || ''
                    }`}
                >
                    © Copyright {new Date().getFullYear()}. ALL RIGHTS RESERVED
                    BY RELOY
                </p>
            )}
        </div>
    );
};

export default Footer2;
